if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.removeSuccessMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.error = false;

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            const nextStepLink = this.getNextStepLink();

            if (!nextStepLink) {
              this.openCartDrawer(response);
            } else {
              this.updateCartIcon(response);
              this.showSuccessMessage(nextStepLink);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            if (spinner) spinner.classList.add('hidden');

            if (typeof CartPerformance !== 'undefined') {
              CartPerformance.measureFromEvent('add:user-action', evt);
            }
          });
      }

      showSuccessMessage(nextStepLink) {
        const message = document.createElement('div');
        message.className = 'product-form-success-message';
        message.innerHTML = `
          <div class="product-form-success-text">
        ✓ נוסף בהצלחה
          </div>
          <a href="${nextStepLink}" class="product-form-next-step-button">
           המשיכו לשלב הבא ←
          </a>
        `;

        this.form.insertAdjacentElement('afterend', message);
      }

      removeSuccessMessage() {
        const oldMessage =
          this.parentElement.querySelector('.product-form-success-message') ||
          this.querySelector('.product-form-success-message');

        if (oldMessage) oldMessage.remove();
      }

      getNextStepLink() {
        const progressBar = document.querySelector('.nfm-steps');

        if (!progressBar) return null;

        const allSteps = Array.from(progressBar.querySelectorAll('.nfm-step'));
        if (!allSteps.length) return null;

        const activeStep = progressBar.querySelector('.nfm-step.active');
        if (!activeStep) return null;

        const activeIndex = allSteps.indexOf(activeStep);

        if (activeIndex === -1 || activeIndex >= allSteps.length - 1) return null;

        const nextStep = allSteps[activeIndex + 1];

        return nextStep ? nextStep.getAttribute('href') : null;
      }

      openCartDrawer(response) {
        const cartDrawer = document.querySelector('cart-drawer');

        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');

          if (typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(response);
            return;
          }

          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
            return;
          }

          cartDrawer.classList.add('active');
          document.body.classList.add('overflow-hidden');
          return;
        }

        const cartNotification = document.querySelector('cart-notification');

        if (cartNotification && typeof cartNotification.renderContents === 'function') {
          cartNotification.renderContents(response);
        } else {
          window.location = window.routes.cart_url;
        }
      }

      updateCartIcon(response) {
        if (!response || !response.sections) return;

        const cartIcon = document.getElementById('cart-icon-bubble');
        const newCartIconHTML = response.sections['cart-icon-bubble'];

        if (cartIcon && newCartIconHTML) {
          const parsedHTML = new DOMParser().parseFromString(newCartIconHTML, 'text/html');
          const newCartIcon = parsedHTML.getElementById('cart-icon-bubble');

          if (newCartIcon) {
            cartIcon.innerHTML = newCartIcon.innerHTML;
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}